module.exports = __webpack_public_path__ + "static/media/RecomendaNatalMTG.ee0c30ee.jpg";